import { Injectable } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs'
import { catchError, tap } from 'rxjs/operators'
import { Store } from '@ngrx/store'
import { setLoadingState, unauthorizedUser } from '@adex/store/actions/global.actions'
import { environment } from '../../../environments'
import { LoadingStateType } from '@adex/shared/models/states/loading.state'
import { LoadingStateCreator } from '@adex/store/utils/loading-state-creator'
import { getUrlsAlias } from '@adex/shared/network/urls'


@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {

  constructor(private readonly store: Store) {
  }

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isExclude = LoadingStateCreator.checkInBlackList(request.url)
    const aliasUrl = getUrlsAlias(request.url)
    const url = !isExclude ? `${ environment.apiHost }${ aliasUrl }` : aliasUrl
    const newRequest = request.clone({
      url,
      withCredentials: true
    })
    if (!isExclude) this.store.dispatch(setLoadingState({ url: request.url, state: LoadingStateType.loading }))
    return next.handle(newRequest).pipe(
      tap((response: HttpResponse<any>) => {
        if (!response.status) return
        if (response.status > 399) return
        if (isExclude) return
        this.store.dispatch(setLoadingState({ url: request.url, state: LoadingStateType.success }))
      }),
      catchError(err => {
        if (!isExclude) this.store.dispatch(setLoadingState({ url: request.url, state: LoadingStateType.error, error: err }))
        this.handleError(err)
        throw err
      })
    )
  }

  private handleError(err: HttpErrorResponse): void {
    if (!err.status) return
    if (err.status === 401) return this.store.dispatch(unauthorizedUser())
  }
}
